/**
 * @generated SignedSource<<411aad3867ae550761a560a05cd95cb6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ClientEventSignUpStatus = "CHECKED_IN" | "CONFIRMED" | "NONE" | "WAITLIST";
import { FragmentRefs } from "relay-runtime";
export type useInitEventSignUps_event$data = {
  readonly eventSeries: {
    readonly facility: {
      readonly club: {
        readonly supportsPublic: boolean;
      } | null | undefined;
    };
  };
  readonly memberSignUpProxyAllowed: boolean | null | undefined;
  readonly signUpStatusForClient: ClientEventSignUpStatus | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"useCurrentSignUp_event">;
  readonly " $fragmentType": "useInitEventSignUps_event";
};
export type useInitEventSignUps_event$key = {
  readonly " $data"?: useInitEventSignUps_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"useInitEventSignUps_event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "memberId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useInitEventSignUps_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "memberSignUpProxyAllowed",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useCurrentSignUp_event"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "clientId",
          "variableName": "memberId"
        }
      ],
      "kind": "ScalarField",
      "name": "signUpStatusForClient",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventSeries",
      "kind": "LinkedField",
      "name": "eventSeries",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Facility",
          "kind": "LinkedField",
          "name": "facility",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Club",
              "kind": "LinkedField",
              "name": "club",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "supportsPublic",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "d4e7ef9662bd93007e61e8cdff5e9777";

export default node;
